export async function fileToBase64(file, maxBytes = 3 * 1024 * 1024) {
  if (!file) return null;
  if (file.size > maxBytes) {
    throw new Error("Image too large (max 3MB)");
  }
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const s = reader.result || "";
      // strip data: prefix
      const idx = s.indexOf(",");
      resolve(idx >= 0 ? s.slice(idx + 1) : s);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
